import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
const Home = () => {
  const [userName, setUserName] = useState('');
  const [userUsername, setUserUsername] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    function getCookie(cookieName) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${cookieName}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return '';
    }
 
    const token = localStorage.getItem("token")
    const decodedToken = jwtDecode(token);

    const username = decodedToken.username;
     const name = decodedToken.name;

      setUserName(name);
     setUserUsername(username);

    //setUserName(getCookie('name'));
    //setUserUsername(getCookie('username'));




  }, []);
 
  const handleLogout = () => {
    localStorage.removeItem('token');
    document.cookie = 'name=; Max-Age=0; path=/';
    document.cookie = 'username=; Max-Age=0; path=/';
    navigate('/');
  };

  const navigationItems = [
    { 
      label: 'Items', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
        </svg>
      ),
      path: '/myitems?db=mtj',
      color: '#3498db'
    },
    { 
      label: 'Orders', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0"></path>
        </svg>
      ),
      path: '/myorders',
      color: '#e74c3c'
    },
    { 
      label: 'Invoices', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      ),
      path: '/myinvoices',
      color: '#f39c12'
    },
    { 
      label: 'Support', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
      ),
      path: '/support',
      color: '#27ae60'
    },
    { 
      label: 'Banners', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="9" y1="21" x2="9" y2="9"></line>
        </svg>
      ),
      path: '/mybanners',
      color: '#8e44ad'
    },
    { 
      label: 'Users', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
      path: '/myusers',
      color: '#2c3e50'
    }
  ];
  
  navigationItems.push({
    label: 'Accounting',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="3" y1="9" x2="21" y2="9"></line>
        <line x1="9" y1="21" x2="9" y2="9"></line>
      </svg>
    ),
    path: '/myaccounting',
    color: '#2c3e50'
  });
  
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header */}
      <header style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '20px',
        color: 'white',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '15px'
          }}>
            <div style={{
              width: '45px',
              height: '45px',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              fontWeight: '500',
              backdropFilter: 'blur(10px)',
              border: '2px solid rgba(255, 255, 255, 0.3)'
            }}>
              {userName.charAt(0).toUpperCase()}
            </div>
            <div>
              <h2 style={{
                margin: '0',
                fontSize: '20px',
                fontWeight: '600'
              }}>Welcome, {userName}</h2>
              <p style={{
                margin: '4px 0 0 0',
                fontSize: '14px',
                opacity: '0.9'
              }}>{userUsername}</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            style={{
              padding: '10px 20px',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              color: 'white',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(10px)'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            Logout
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '40px 20px',
        width: '100%',
        flex: '1 0 auto'
      }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '300',
          color: '#2c3e50',
          marginBottom: '40px',
          textAlign: 'center'
        }}>Control Panel</h1>

        {/* Navigation Grid */}
        <style>
          {`
            @media (max-width: 767px) {
              .navigation-grid {
                grid-template-columns: repeat(2, 1fr) !important;
              }
            }
            @media (min-width: 768px) and (max-width: 1023px) {
              .navigation-grid {
                grid-template-columns: repeat(3, 1fr) !important;
              }
            }
            @media (min-width: 1024px) {
              .navigation-grid {
                grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)) !important;
              }
            }
          `}
        </style>
        <div className="navigation-grid" style={{
          display: 'grid',
          gap: '25px',
          padding: '20px 0'
        }}>
          {navigationItems.map(({ label, icon, path, color }) => (
            <button
              key={label}
              onClick={() => navigate(path)}
              style={{
                backgroundColor: 'white',
                border: 'none',
                borderRadius: '16px',
                padding: '30px',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
                position: 'relative',
                overflow: 'hidden',
                width: '100%'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-5px)';
                e.target.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
              }}
            >
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '12px',
                backgroundColor: `${color}10`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: color
              }}>
                {icon}
              </div>
              <span style={{
                fontSize: '16px',
                fontWeight: '500',
                color: '#2c3e50'
              }}>{label}</span>
              <div style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '4px',
                height: '100%',
                backgroundColor: color,
                opacity: '0.7'
              }} />
            </button>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        textAlign: 'center',
        padding: '20px',
        color: '#95a5a6',
        fontSize: '14px',
        backgroundColor: 'white',
        borderTop: '1px solid #eee',
        flexShrink: 0
      }}>
        © 2025 Intelligent Systems. All rights reserved.
      </footer>
    </div>
  );
};

export default Home;
